import { AfterViewInit, Directive, ElementRef, OnDestroy, inject } from '@angular/core';

// Pins scroll to the bottom when content changes. Driven by a MutationObserver rather than
// AfterViewChecked so the scrollHeight layout read runs only on real content changes, not on
// every change-detection pass of the host view (battle mounts several of these on a hot path).
@Directive({
  selector: '[autoScroll]'
})
export class AutoScrollDirective implements AfterViewInit, OnDestroy {
  private elementRef = inject(ElementRef<HTMLElement>);
  private observer: MutationObserver | undefined;

  ngAfterViewInit() {
    const element = this.elementRef.nativeElement;
    element.scrollTop = element.scrollHeight;
    this.observer = new MutationObserver(() => {
      element.scrollTop = element.scrollHeight;
    });
    this.observer.observe(element, { childList: true, subtree: true, characterData: true });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
